export default __webpack_public_path__ + "static/media/info-icon.e7fb9d35.svg";